(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-carousel"] && !Shopify.designMode) return;
  try {
    
  class HeroCarouselComponent extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.hero-carousel__track');
      this.slides = Array.from(this.querySelectorAll('.hero-carousel__slide'));
      this.dots = Array.from(this.querySelectorAll('.hero-carousel__dot'));
      this.prevButton = this.querySelector('.hero-carousel__arrow--prev');
      this.nextButton = this.querySelector('.hero-carousel__arrow--next');
      this.playPauseButton = this.querySelector('.hero-carousel__playpause');
      this.liveRegion = this.querySelector('.hero-carousel__live-region');

      this.index = 0;
      this.autoplayTimer = null;
      this.manuallyPaused = false;
      this.dragStartX = undefined;

      if (this.slides.length <= 1) {
        this.slides.forEach((slide) => slide.removeAttribute('aria-hidden'));
        return;
      }

      this.prevButton?.addEventListener('click', () => this.go(this.index - 1));
      this.nextButton?.addEventListener('click', () => this.go(this.index + 1));

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.go(Number(dot.dataset.index)));
      });

      this.playPauseButton?.addEventListener('click', () => {
        this.manuallyPaused = !this.manuallyPaused;
        this.playPauseButton.classList.toggle('is-paused', this.manuallyPaused);
        this.playPauseButton.setAttribute('aria-pressed', String(this.manuallyPaused));
        this.playPauseButton.setAttribute('aria-label', this.manuallyPaused ? 'Play autoplay' : 'Pause autoplay');
        if (this.manuallyPaused) {
          this.stopAutoplay();
        } else {
          this.startAutoplay();
        }
      });

      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') this.go(this.index - 1);
        if (event.key === 'ArrowRight') this.go(this.index + 1);
      });

      this.addEventListener('pointerdown', (event) => {
        this.dragStartX = event.clientX;
      });
      this.addEventListener('pointerup', (event) => {
        if (this.dragStartX === undefined) return;
        const delta = event.clientX - this.dragStartX;
        if (Math.abs(delta) > 40) this.go(this.index + (delta < 0 ? 1 : -1));
        this.dragStartX = undefined;
      });

      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
      this.addEventListener('focusin', () => this.stopAutoplay());
      this.addEventListener('focusout', () => this.startAutoplay());

      this.update();
      this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

    go(nextIndex) {
      const total = this.slides.length;
      this.index = (nextIndex + total) % total;
      this.update();
    }

    update() {
      this.track.style.transform = `translateX(-${this.index * 100}%)`;

      this.slides.forEach((slide, i) => {
        const isActive = i === this.index;
        slide.setAttribute('aria-hidden', String(!isActive));
        slide.toggleAttribute('inert', !isActive);
      });

      this.dots.forEach((dot, i) => {
        const isActive = i === this.index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', String(isActive));
      });

      if (this.liveRegion) {
        this.liveRegion.textContent = `Slide ${this.index + 1} of ${this.slides.length}`;
      }
    }

    startAutoplay() {
      if (this.manuallyPaused) return;
      if (this.dataset.autoplay !== 'true') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.stopAutoplay();
      const speed = Number(this.dataset.autoplaySpeed) || 5000;
      this.autoplayTimer = window.setInterval(() => this.go(this.index + 1), speed);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        window.clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }
  }

  if (!customElements.get('hero-carousel-component')) {
    customElements.define('hero-carousel-component', HeroCarouselComponent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
